import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';



type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class NotificationPreferenceService {
    private resourceUrl = SERVER_API_URL + 'api/notification-preferences';

    constructor(private http: HttpClient) {}

   

    update(data: any): Observable<EntityResponseType> {
        return this.http.put<any>(this.resourceUrl, data, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

}
